import Loading from '../components/course/loading';
<template><Loading /></template>
